import { Modal } from "@mui/material";
import { CommonBatchBrandForm } from "../../components/brand-batch/brand-batch-form";
import ModalBox from "../../components/common/modal";
import { Brand } from "../playground/types";

export const BrandEdit: React.FC<{
  onClose: () => void;
  brandId: string;
  brandData: Brand;
}> = ({ onClose, brandId, brandData }) => {
  return (
    <Modal open={true} onClose={onClose} aria-labelledby="brand-modal">
      <ModalBox title={`Edit Brand ${brandData.name}`}>
        <CommonBatchBrandForm
          onClose={onClose}
          type="brand"
          id={brandId}
          data={brandData}
        />
      </ModalBox>
    </Modal>
  );
};
